<template>
  <div class="collage__products-info-container">
    <div class="collage__products-info q-position-absolute q-row" v-if=showOnHover :class="{active:showOnHover}">
      <div class="q-row q-px-5 q-mb-2 q-bg-white get-the-look__gtl-container">
        <GetTheLook v-for="product in products" :key="product.id"
                    :product="product" :use-as-separate="useAsSeparate"/>
      </div>
    </div>
    <div class="show-products__button q-position-absolute" :class="{active: showOnHover}" @click="showOnHover = !showOnHover">
      <div class="show-products__button-icon q-position-relative"></div>
    </div>
  </div>
</template>
<script setup lang="ts">
import {defineProps, ref, PropType, computed} from 'vue'
import GetTheLook from '@/components/GetTheLook/GetTheLook.vue'

const props = defineProps({
  products: [],
  useAsSeparate: {
    type: Boolean as PropType<boolean>,
    default: true
  }
});


const showOnHover = ref(false);
// co
</script>
<style>
.collage__products-info-container{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.collage__products-info {
  top: 100%;
  z-index: 10;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: rgba(255, 255, 255, 0.27);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5.8px);
  -webkit-backdrop-filter: blur(5.8px);
}



.collage__products-info  .get-the-look__product{
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;
  border-radius: 0.5rem;
  background-color: #fff;
}

.collage__products-info  .get-the-look__gtl-container{
  background-color: unset!important;
  margin-left: 10px;
}

.collage__products-info.active  h2.get-the-look__title{
  font-size: 0.75rem!important;
}
.collage__products-info.active h6.get-the-look__brand{
  font-size: 0.75rem!important;
}
.collage__products-info.active span.get-the-look__price-text{
  font-size: 0.75rem!important;
}
.collage__products-info.active strong.get-the-look__price{
  font-size: 0.75rem!important;
}
.collage__products-info.active .get-the-look__product img {
  border-radius: 5px;
  max-width: 100%;
  max-height: 100px;
}

.collage__products-info.active {
  top: 0;
}

.show-products__button-icon {
 position: relative;
  left: 0;
  transform: translate(36%, -50%) rotate(90deg);

}
.show-products__button-icon::after{
  position: absolute;
  left: 50%;
  top: 50%;
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  margin-left: auto;
  content: "";
  background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e");
  transform: rotate(90deg) translate(25%, -50%) !important;
  background-repeat: no-repeat;
  background-size: 1.5rem;
}


.show-products__button{
  left: 45%;
  bottom: 0px;
  z-index: 100;
  background: #fff;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}
.show-products__button.active{
  transform: rotate(180deg);
}

</style>